const FALLBACK_LOCALE = 'en'

/** Повертає рядок для заданої локалі з поля (рядок або Record<locale, string>). */
export function resolveLocalizedString(
  value: string | Record<string, string> | undefined,
  locale: string,
  fallbackLocale: string = FALLBACK_LOCALE
): string {
  if (value == null) return ''
  if (typeof value === 'string') return value
  return value[locale] ?? value[fallbackLocale] ?? Object.values(value)[0] ?? ''
}
